import { render, staticRenderFns } from "./WeeksRanking.vue?vue&type=template&id=4344740a&"
import script from "./WeeksRanking.vue?vue&type=script&lang=js&"
export * from "./WeeksRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports